import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { Chapter } from "./Chapter";
import { EXPERIENCE } from "@/data/content";

export const Experience = () => (
  <section id="experience" className="relative z-10 py-24 md:py-32 lg:py-40">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <Chapter num="02" title="Experience" kicker="Timeline" />

      <div className="border-t border-[#d2d5ce]">
        {EXPERIENCE.map((e, i) => (
          <Reveal key={`${e.role}-${e.date}`} delay={i * 0.05}>
            <div className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 border-b border-[#d2d5ce] hover:border-[#16324f] transition-colors duration-500">
              <div className="md:col-span-3">
                <span className="font-mono-plex text-[13.5px] text-[#2e7d6b] tracking-wide">
                  {e.date}
                </span>
              </div>
              <div className="md:col-span-6">
                <h3 className="font-serif-display text-2xl md:text-[28px] text-[#16324f] leading-tight group-hover:translate-x-1 transition-transform duration-500">
                  {e.role}
                </h3>
                <p className="mt-1.5 text-[15px] italic text-[#48606f]">{e.org}</p>
              </div>
              <div className="md:col-span-3">
                <p className="text-[15.5px] text-[#3a4d5c] leading-relaxed">{e.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
